export default __webpack_public_path__ + "static/media/bg-engage-footer.2dd32eaa.svg";